import { motion } from "framer-motion"
import { Check } from "lucide-react"
import styles from "../CalculadoraDeMateriales.module.scss"

const CalculadoraMaterialAddedToast = () => (
  <motion.div className={styles.materialAddedToast} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
    <Check size={20} className={styles.materialAddedToast_icon} />
    <span>Material agregado</span>
  </motion.div>
)

export default CalculadoraMaterialAddedToast
